import { render, staticRenderFns } from "./BiomasaMesAnio.vue?vue&type=template&id=6b389413&scoped=true&"
import script from "./BiomasaMesAnio.vue?vue&type=script&lang=js&"
export * from "./BiomasaMesAnio.vue?vue&type=script&lang=js&"
import style0 from "./BiomasaMesAnio.vue?vue&type=style&index=0&id=6b389413&scoped=true&lang=css&"
import style1 from "./BiomasaMesAnio.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b389413",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VRow,VSelect,VSimpleTable})
